import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import RolePermissionItem from './RolePermissionItem.jsx';
import IconRoles from '../../../components/images/IconRoles.jsx';
import IconApprove from '../../../components/images/IconApprove.jsx';
import IconCalendar from '../../../components/images/IconCalendar.jsx';
import IconContact from '../../../components/images/IconContact.jsx';
import IconFiles from '../../../components/images/IconFiles.jsx';
import IconOrganize from '../../../components/images/IconOrganize.jsx';
import IconRocket from '../../../components/images/IconRocket.jsx';
import IconOpportunities from '../../../components/images/IconOpportunities.jsx';
import IconTicketOutline from '../../../components/images/IconTicketOutline.jsx';
import IconTicketAdminOutline from '../../../components/images/IconTicketAdminOutline.jsx';
import IconWrapper from '../IconWrapper.jsx';
import '../../../resources/styles/accordion.scss';

const RolePermissions = ({
    organizationId,
    permissionsList,
    sectionText,
    editMode,
    roleType,
    maxPermissions,
    adminPermissions
}) => {
    const renderIcon = (permissionValue) => {
        switch (permissionValue) {
            case 'users':
                return (
                    <IconWrapper>
                        <IconApprove className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'roles':
                return (
                    <IconWrapper>
                        <IconRoles className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'contacts':
                return (
                    <IconWrapper>
                        <IconContact className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'organizations':
                return (
                    <IconWrapper>
                        <IconOrganize className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'owned-organizations':
                return (
                    <IconWrapper>
                        <IconOrganize className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'calendar':
                return (
                    <IconWrapper>
                        <IconCalendar className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'projects':
                return (
                    <IconWrapper>
                        <IconRocket className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'opportunities':
                return (
                    <IconWrapper>
                        <IconOpportunities className='stroke-theme1-white w-[30px] h-[30px]' />
                    </IconWrapper>
                );
            case 'files':
                return (
                    <IconWrapper>
                        <IconFiles className='stroke-theme1-white' />
                    </IconWrapper>
                );
            case 'submit-tickets':
                return (
                    <IconWrapper>
                        <IconTicketOutline className='stroke-theme1-white fill-transparent w-[20px] h-[20px]' />
                    </IconWrapper>
                );
            case 'tickets':
                return (
                    <IconWrapper>
                        <IconTicketAdminOutline className='stroke-theme1-white fill-transparent' />
                    </IconWrapper>
                );
            default:
                return (
                    <IconWrapper>
                        <span className='text-theme1-white'>?</span>
                    </IconWrapper>
                );
        }
    };

    return (
        <div className='mt-6'>
            <div className='font-bold mb-5 text-[22px] text-theme1-primary'>{sectionText}</div>
            <Accordion multiple className='roles-accordion' activeIndex={permissionsList.map((permission, key) => key)}>
                {permissionsList.map((permission) => {
                    if (roleType === 'admin' || (roleType === 'user' && !adminPermissions.includes(permission.value))) {
                        return (
                            <AccordionTab
                                key={permission.value}
                                header={
                                    <span className='flex items-center gap-2 w-full'>
                                        {renderIcon(permission.value)}
                                        <span className='text-theme1-primary2 text-base font-semibold'>
                                            {permission.label}
                                        </span>
                                    </span>
                                }
                            >
                                <RolePermissionItem
                                    permission={permission}
                                    organizationId={organizationId}
                                    maxPermission={maxPermissions[permission.value]}
                                />
                            </AccordionTab>
                        );
                    }

                    return null;
                })}
            </Accordion>
        </div>
    );
};

export default RolePermissions;
